'use client'

import { reloadPage } from '@marketplace-web/browser/browser-navigation-util'
import { confirmCancellationAgreement } from '@marketplace-web/conversation-shipping/conversation-shipping-data'
import { ResponseCode } from '@marketplace-web/core-api/api-client-util'

import { ConversationActionProps } from '@marketplace-web/messaging/conversation-action-data'
import { ConversationActionButton } from '@marketplace-web/messaging/conversation-action-feature'
import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'

type Props = ConversationActionProps

const CancellationConfirm = ({ title, primary, size, theme, inverse }: Props) => {
  const { conversation } = useConversationContext()

  const transactionId = conversation?.transaction?.id

  async function confirmAgreement() {
    if (!transactionId) return

    const response = await confirmCancellationAgreement(transactionId)

    if (response.code === ResponseCode.Ok) reloadPage()
  }

  if (!transactionId) return null

  return (
    <ConversationActionButton
      text={title}
      primary={primary}
      size={size}
      theme={theme}
      inverse={inverse}
      onClick={confirmAgreement}
    />
  )
}

export default CancellationConfirm
